import SlideButton from "./SlideButton";

export default SlideButton;